/**
 * O que faz: apresenta círculo responsivo à voz e controles acessíveis de gravação da base.
 * Onde usa: BaseConhecimentoClinica, ao escolher Áudio.
 * Conexões: useGravacaoConhecimento e componentes compartilhados Button.
 * Tabelas: Nenhuma.
 * Data: 29/09/2026.
 */
import { Mic, Square } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useGravacaoConhecimento } from './useGravacaoConhecimento';
import './conhecimento.css';
import { useEffect } from 'react';

export function GravadorConhecimentoClinica({ aoConcluir, ocupado, aoMudarGravacao }: { aoConcluir: (arquivo: File) => void; ocupado: boolean; aoMudarGravacao?: (ativo: boolean) => void }) {
  const gravacao = useGravacaoConhecimento(aoConcluir);
  // O editor impede salvar uma transcrição antiga enquanto o microfone captura uma nova versão.
  useEffect(() => { aoMudarGravacao?.(gravacao.gravando || gravacao.preparando); }, [gravacao.gravando, gravacao.preparando, aoMudarGravacao]);
  const tempo = `${Math.floor(gravacao.segundos / 60).toString().padStart(2, '0')}:${(gravacao.segundos % 60).toString().padStart(2, '0')}`;
  return (
    <div className="flex flex-col items-center gap-4 py-5">
      {/* Só transform responde à voz; movimento reduzido mantém círculo e indicador textual estáticos. */}
      <div ref={gravacao.circuloRef} data-gravando={gravacao.gravando} className="conhecimento-circulo-voz flex h-24 w-24 items-center justify-center rounded-full bg-accent text-accent-foreground" aria-hidden="true">
        <Mic className="h-8 w-8" />
      </div>
      <p role="status" className="text-center text-sm text-muted-foreground">
        {gravacao.gravando ? `Ouvindo · ${tempo} / 05:00` : gravacao.preparando ? 'Aguardando acesso ao microfone…' : ocupado ? 'Transcrevendo o áudio…' : 'Conte informações da clínica em até 5 minutos.'}
      </p>
      <p className="max-w-md text-center text-xs text-muted-foreground">Fale sobre serviços, horários e regras de atendimento. Ao terminar, revise a transcrição antes de salvar.</p>
      <div className="flex flex-wrap justify-center gap-2">
        {gravacao.gravando ? <>
          <Button onClick={() => gravacao.parar()}><Square className="mr-2 h-4 w-4" />Finalizar e transcrever</Button>
          <Button variant="outline" onClick={() => gravacao.parar(true)}>Descartar áudio</Button>
        </> : <Button onClick={() => void gravacao.iniciar()} disabled={ocupado || gravacao.preparando}><Mic className="mr-2 h-4 w-4" />Gravar áudio</Button>}
      </div>
      {gravacao.erro && <p role="alert" className="text-center text-sm text-destructive">{gravacao.erro}</p>}
    </div>
  );
}
